import React from "react";
import { Box, Typography } from "@material-ui/core";
import { DateRangePicker } from "halifax";
import dayjs from "dayjs";

import { MonthAndDatePickerConnectorProps } from "./container";
import "./styles.scss";
import {
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../../../../context/experiments";
import { AVAILABLE, getExperimentVariant } from "@capone/experiments";
import clsx from "clsx";

export interface IMonthAndDatePickerProps
  extends MonthAndDatePickerConnectorProps {
  viewType: MonthAndDatePickerType;
  header?: JSX.Element | string;
  // focusedMonthIndex must be given in order to make columnView focus on an arbitrary month
  focusedMonthIndex?: number;
  // setFocusedMonthIndex must be given for working with the groupView + columnView combination
  setFocusedMonthIndex?: (index: number) => void;
  setFromDate?: (date: Date | null) => void;
  setUntilDate?: (date: Date | null) => void;
  from: Date | null;
  until: Date | null;
  className?: string;
  unavailableDates?: Date[];
}

export const MonthAndDatePicker = (props: IMonthAndDatePickerProps) => {
  const {
    pickerType,
    from,
    until,
    setFromDate,
    setUntilDate,
    header,
    viewType,
    className,
    unavailableDates,
  } = props;

  const expState = useExperiments();

  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  return (
    <>
      {header && (
        <Box className="month-and-date-picker-header-container">
          {typeof header === "string" ? (
            <Typography variant="body2">{header}</Typography>
          ) : (
            header
          )}
        </Box>
      )}
      <DateRangePicker
        className={clsx(className, { xmod: isXmodRedesign })}
        minAllowedDate={dayjs().toDate()}
        maxAllowedDate={dayjs().add(1, "year").toDate()}
        minNumDays={1}
        startDate={from}
        endDate={until}
        setStartDate={setFromDate}
        setEndDate={setUntilDate}
        months={[]}
        priceTags={[]}
        pickerType={pickerType}
        columnView={viewType === MonthAndDatePickerType.Column}
        unavailableDates={unavailableDates}
      />
    </>
  );
};

export enum MonthAndDatePickerType {
  Horizontal,
  Column,
  Group,
}
